<template>
  <div>
    <c-table
      :columns="columns"
      :fields="fields"
      url="/allmessage/homej"
      :fetchPage="true"
      ref="table"
      :defaultParam ="{type: 'project'}"
    >
      <el-button type="primary" slot="operate" @click="$router.push('/project/project-edit')" v-permission:write>项目新增</el-button>
      <el-table-column v-for="(item,index) in columns.filter(item => item.slot !== 'operation')" :key="index" :slot="item.slot" :label="item.label" >
        <template v-slot="{row}">
          <template v-if="Array.isArray(row[item.slot])" >
            <el-button
              type="text"
              v-for="(text ,count) in row[item.slot]" :key="count"
              @click="$router.push(`/project/project-edit?id=${row.id}`)"
            >{{text.value}}</el-button>
          </template>
          <template v-else>
            <el-button
              type="text"
              @click="$router.push(`/project/project-edit?id=${row.id}`)"
            >{{row[item.slot] != undefined ? row[item.slot].value : '' }}</el-button>
          </template>
        </template>
      </el-table-column>
      <el-table-column slot="operation" label="操作" width="160" fixed="right">
        <template v-slot="{row}">
          <el-button type="primary" size="mini" @click="$router.push(`/project/project-edit?id=${row.id}`)" v-permission:read>详情</el-button>
          <el-button size="mini" @click="remove(row)" v-permission:write>删除</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>
<script>
import CTable from '@/components/common/table'
import http from '@/plugins/axios'

export default {
  name: 'project-lists',
  components: { CTable },
  data() {
    return {
      fields: [
        {
          prop: 'project_responsor',
          placeholder: '项目负责人',
          clearable: true,
          component: 'select',
          options: []
        },
        {
          prop: 'project_status',
          placeholder: '项目状态',
          component: 'select',
          clearable: true,
          options: []
        },
        {
          prop: 'sale_responsor',
          placeholder: '销售负责人',
          component: 'select',
          clearable: true,
          options: []
        },
        {
          prop: 'jiesuan_type',
          placeholder: '结算类型',
          component: 'select',
          clearable: true,
          options: []
        }
      ],
      columns: [
        { prop: 'fullname', label: '项目名称', width: 180 },
        { slot: 'hangye', label: '行业' },
        { slot: 'jiesuan_type', label: '结算类型' },
        { slot: 'project_responsor', label: '项目负责人' },
        { slot: 'project_status', label: '项目状态' },
        { slot: 'sale_responsor', label: '销售负责人' },
        { slot: 'type1', label: '类型一' },
        { slot: 'type2', label: '类型二' },
        { slot: 'corp', label: '公司' },
        { slot: 'operation', label: '操作' }
      ],
      model: null
    }
  },
  beforeRouteEnter (to, from, next) {
    http.post('/allmessage/getchoice', { type: 'project' }).then(res => {
      next(vm => {
        res.data.data.map(x => {
          if (['project_responsor', 'project_status', 'sale_responsor', 'jiesuan_type'].includes(x.choice)) {
            x.list.map(y => {
              y.value = y.id
              y.label = y.name
            })
            vm.fields.find(item => item.prop === x.choice).options = x.list
            // console.log(vm.fields.find(item => item.prop === x.choice))
          }
        })
      })
    })
  },
  methods: {
    detail(type, id) {
      // console.log('详情', type, id)
      id && this.$router.push(`/project/project-edit?id=${id}`)
    },
    remove(project) {
      this.$confirm(`删除项目${project.fullname}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/allmessage/deletej', {
          type: 'project',
          id: project.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.$refs['table'].reload()
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped></style>
